var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41.4959,
    height: 41.4959,
    rx: 10.374,
    fill: "#5BF0A5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5505 17.7089L21.8805 16.0592L22.2104 17.7089C22.8198 20.7559 25.2015 23.1376 28.2484 23.7469L29.8981 24.0769L28.2484 24.4068C25.2015 25.0162 22.8198 27.3979 22.2104 30.4448L21.8805 32.0945L21.5505 30.4448C20.9411 27.3979 18.5594 25.0162 15.5125 24.4068L13.8628 24.0769L15.5125 23.7469C18.5594 23.1376 20.9411 20.7559 21.5505 17.7089Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7418 11.6071L14.9227 10.7026L15.1036 11.6071C15.4377 13.2777 16.7436 14.5836 18.4143 14.9178L19.3188 15.0987L18.4143 15.2796C16.7436 15.6137 15.4377 16.9196 15.1036 18.5902L14.9227 19.4948L14.7418 18.5902C14.4077 16.9196 13.1018 15.6137 11.4312 15.2796L10.5266 15.0987L11.4312 14.9178C13.1018 14.5836 14.4077 13.2777 14.7418 11.6071Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1997 13.8395L28.331 13.1833L28.4622 13.8395C28.7046 15.0515 29.652 15.9988 30.8639 16.2412L31.5201 16.3725L30.8639 16.5037C29.652 16.7461 28.7046 17.6934 28.4622 18.9054L28.331 19.5616L28.1997 18.9054C27.9573 17.6934 27.01 16.7461 25.7981 16.5037L25.1418 16.3725L25.7981 16.2412C27.01 15.9988 27.9573 15.0515 28.1997 13.8395Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.dd68f9d6e4e772b805d087f6c0d164f3.svg";
export { ForwardRef as ReactComponent };